module.exports = __webpack_public_path__ + "static/img/12ai.de1ad0bb.gif";